import 'jquery'
import Home from '@scripts/components/home'

document.addEventListener('DOMContentLoaded', () => {
    new Home()
})
